import { Button } from 'primereact/button';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router';
import styles from './AddNewBillingTerms.scss';
import { AGREEMENT_TYPE } from '../../config/constants';
import cn from 'classnames';

export const AddNewBillingTerms = ({
  onConfirm,
  agreementType,
  actingAs,
  review = false,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isSelfRequest = agreementType === AGREEMENT_TYPE.SELF && !review;

  const isThirdRequest = agreementType === AGREEMENT_TYPE.THIRD && !review;

  const isThirdReview = agreementType === AGREEMENT_TYPE.THIRD && review;

  const isSelfReview = agreementType === AGREEMENT_TYPE.SELF && review;

  return (
    <div className={styles.termsAndConditionsContainer}>
      <h2>
        {agreementType === AGREEMENT_TYPE.SELF
          ? t(
              'special_billing.self-billing-agreement-terms-and-conditions-header',
            )
          : t(
              'special_billing.third-party-billing-agreement-terms-and-conditions-header',
            )}
      </h2>
      <div className={cn('content', styles.termsAndConditions)}>
        {isSelfRequest && (
          <div
            dangerouslySetInnerHTML={{
              __html: t(
                'special_billing.self-billing-request-agreement-terms-and-conditions',
              ),
            }}
          />
        )}

        {isSelfReview && (
          <div
            dangerouslySetInnerHTML={{
              __html: t(
                'special_billing.self-billing-review-agreement-terms-and-conditions',
              ),
            }}
          />
        )}

        {isThirdRequest && (
          <div
            dangerouslySetInnerHTML={{
              __html: t(
                'special_billing.third-party-request-agreement-terms-and-conditions',
              ),
            }}
          />
        )}

        {isThirdReview && (
          <div
            dangerouslySetInnerHTML={{
              __html: t(
                'special_billing.third-party-review-agreement-terms-and-conditions',
              ),
            }}
          />
        )}
      </div>
      <div className={styles.actions}>
        <Button outlined onClick={() => navigate('../')}>
          <span className="pi pi-times" />
          <span>{t('common.back')}</span>
        </Button>
        <Button onClick={() => onConfirm(false)}>
          <span className="pi pi-check" />
          <span>{t('common.next')}</span>
        </Button>
      </div>
    </div>
  );
};
